import { useEffect } from 'react';

import LandingPageLayout from '@/Layout/LandingPageLayout';

const HomePage = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = 'https://rokit.com';
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <LandingPageLayout title="description.redirect_to" titleInterpolation={{ name: 'rokit.com' }}>
    </LandingPageLayout>
  );
};

export default HomePage;
